import { Lead } from "@justhome/common/api/core";
import { PHONE_PATTERN } from "@justhome/common/constants";
import { InlineNotification, TextField } from "@justhome/react-ui";
import { useApplicationTranslation } from "@lib/hooks/translations";
import { FC, MouseEventHandler } from "react";
import { DeepPartial, useForm } from "react-hook-form";
import FormButtons from "../FormButtons";

export type LeadWallDetailsFormValue = Lead;

interface LeadWallFormProps {
  onSubmit: (value: LeadWallDetailsFormValue) => void;
  isLoading: boolean;
  isError: boolean;
  onPrevious: MouseEventHandler;
  defaultValues: DeepPartial<LeadWallDetailsFormValue>;
}

const LeadWallForm: FC<LeadWallFormProps> = ({
  onSubmit,
  isLoading,
  isError,
  onPrevious,
  defaultValues,
}) => {
  const { t } = useApplicationTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LeadWallDetailsFormValue>({
    defaultValues,
    mode: "onBlur",
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2s">
      <TextField
        autoFocus
        disabled={isLoading}
        {...register("firstName", {
          required: t("error_fill_in"),
        })}
        label={t("opt_in_form_first_name_label")}
        placeholder={t("opt_in_form_first_name_placeholder")}
        errorMessage={errors.firstName?.message}
        enterKeyHint="next"
      />

      <TextField
        disabled={isLoading}
        {...register("lastName", {
          required: t("error_fill_in"),
        })}
        label={t("opt_in_form_last_name_label")}
        placeholder={t("opt_in_form_last_name_placeholder")}
        errorMessage={errors.lastName?.message}
        enterKeyHint="next"
      />

      <TextField
        disabled={isLoading}
        {...register("phone", {
          required: t("error_fill_in"),
          pattern: {
            value: PHONE_PATTERN,
            message: t("error_phone_number"),
          },
        })}
        type="phone"
        label={t("opt_in_form_phone_number_label")}
        errorMessage={errors.phone?.message}
        enterKeyHint="send"
      />

      {isError && (
        <InlineNotification className="mt-2s mb-s" type="error">
          {t("generic_error")}
        </InlineNotification>
      )}

      <FormButtons onPrevious={onPrevious} isLoading={isLoading} />
    </form>
  );
};

export default LeadWallForm;
